import { FC, useContext, useRef } from "react";
import ThriveTitle from "../../common/ThriveTitle";
import { Box } from "@mui/material";
import { Editor } from "@tinymce/tinymce-react";
// Import TinyMCE to load it into global scope
import "tinymce/tinymce";
// Import TinyMCE plugins and themes
import "tinymce/themes/silver";
import "tinymce/icons/default";
import "tinymce/models/dom";
// Import plugins
import "tinymce/plugins/lists";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/table";
import "tinymce/plugins/help";
import { StyledButtonMain } from "../../common/Buttons";
import { UserType } from "../../../interfaces";
import { UserContext } from "../../../context/UserContext";
import { axiosInstance } from "../../../utils/networking";

interface ResourceNotesProps {
  setOpen: (open: boolean) => void;
  resource: any;
  editorType: string;
}

const ResourceNotes: FC<ResourceNotesProps> = ({
  setOpen,
  resource,
  editorType,
}) => {
  const editorRef = useRef(null);
  const { user }: { user: UserType } = useContext(UserContext);
  const handleSave = () => {
    if (!editorRef.current) return;
    //@ts-ignore
    const htmlString = editorRef.current.getContent();
    // console.log(htmlString, resource);
    axiosInstance
      .post(`/resources`, {
        resource: {
          ...resource,
          editorType: editorType,
          notes: htmlString,
        },
      })
      .then((res) => {
        setOpen(false);
        window.location.reload();
      });
  };

  return (
    <>
      <ThriveTitle title="Resource Notes" setOpen={setOpen}></ThriveTitle>
      <Box
        sx={{
          margin: "10px",
          border: "solid 1px #c4c4c4",
          borderRadius: "0 0 10px 10px",
          // overflow: "auto",
          height: "500px",
        }}
      >
        <Editor
          //@ts-ignore
          onInit={(evt, editor) => (editorRef.current = editor)}
          initialValue={resource.notes}
          init={{
            // theme: "advanced",
            // readonly: readonly,
            forced_root_block: "",
            skin_url: "/skins/ui/oxide",
            content_css: "/skins/content/default/content.css",
            plugins: "paste",
            paste_as_text: true,
            height: 500,
            menubar: false,
            toolbar:
              "undo redo | formatselect | " +
              "bold italic backcolor | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat | help",
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            relative_urls: false,
            remove_script_host: false,
          }}
        />
      </Box>
      {user.role === "admin" && (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <StyledButtonMain
            variant="contained"
            size="large"
            sx={{ width: "20%", backgroundColor: "#941566", margin: "auto" }}
            onClick={handleSave}
          >
            Save
          </StyledButtonMain>
        </Box>
      )}
    </>
  );
};

export default ResourceNotes;
